/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-restricted-globals */
/* eslint-disable prefer-destructuring */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'utils/moment';
import SectionHeader from '../../../components/sectionHeader';
import HeaderBack from '../../../components/headerBack/HeaderBack';
import Panel from '../../../components/panel/Panel';
import Button from '../../../components/button/button';
import Loading from '../../../components/loading/loading';
import icon from '../../../icons/Non_Airfield_WorkOrder.png';
import WorkorderStyles from '../../Maintenance/create/workOrderCreate.module.scss';
import FixedFeilds from './FixedFeilds';
import { creatGrossReciepts, editGrossReciepts, getContracts, getGrossRecieptDetail } from '../redux/actions';
import { GetFileName, S3Uploads } from '../../services';

const getQuarter = (month) => {
  if (month >= 1 && month <= 3) return 1; // Q1
  if (month >= 4 && month <= 6) return 2; // Q2
  if (month >= 7 && month <= 9) return 3; // Q3
  if (month >= 10 && month <= 12) return 4; // Q4
  return null; // Invalid month
};

class GrossRecieptsSubmission extends Component {
  state = {
    info: {
      report_date: moment().format(),
      logged_by: {},
      month: moment().format('l').split('/')[0],
      quarter: getQuarter(moment().format('l').split('/')[0]),
      year: moment(),
      attachments: [],
      contract: ''
    },
    showFormErrors: false,
    fieldErrors: {
      logged_by: false,
      report_date: false,
      category: false,
      amount: false,
      contract: true
    },
    loadingStatus: false,
    categories: []
  }


  static getDerivedStateFromProps(props, state) {
    if (props?.user && !props?.match?.params?.id) {
      return {
        ...state,
        info: {
          ...state.info,
          logged_by: {
            id: props.user.id,
            fullname: props.user.fullname
          }
        },
        allCategories: props.user?.gross_receipt_categories
      };
    }
    return state;
  }

  componentDidMount() {
    const {
      getContractList,
      actiondetails
    } = this.props;
    const { id } = this.props.match.params;
    getContractList();
    if (id) {
      actiondetails(id);
    }
  }

  componentDidUpdate(prevProps) {
    const { createRecieptAction, history, gross_receipts, fetchRecieptsAction, user } = this.props;
    if (!prevProps.fetchRecieptsAction?.success && fetchRecieptsAction?.success) {
      const recieptsData = {
        logged_by: {
          id: gross_receipts?.logged_by?.id,
          fullname: gross_receipts?.logged_by?.fullname
        },
        contract: gross_receipts?.contract?.id || '',
        attachments: gross_receipts?.attachments,
        description: gross_receipts?.description || '',
        month: gross_receipts.month,
        quarter: gross_receipts.quarter,
        year: moment(gross_receipts.year)
      };

      const errorsData = {
        contract: !gross_receipts?.contract?.id
      };

      const categoriesTOPush = user?.gross_receipt_categories
        ?.filter(cat1 => !gross_receipts?.category_items?.some(cat2 => cat2.id === cat1.id)) || [];

      this.updateCategories([...gross_receipts?.category_items, ...categoriesTOPush]);
      this.updateErrorState(errorsData);
      this.updateReciept('info', recieptsData);
    }
    if (!prevProps.createRecieptAction.success && createRecieptAction.success) {
      history.push('/gross_receipts/list');
    }
  }

  getTotalRent = (record, type, mag) => {
    let result=0;
    if (type==='gross_sales') {
      result = record.reduce(
        (accumulator, currentValue) => accumulator + parseFloat(currentValue?.gross_sales),
        0
      );
    } else {
    result = record.reduce(
      (accumulator, currentValue) => accumulator + parseFloat(currentValue?.percentage_rent),
      0
    );
  }
    if (type === 'rent') {
      if (mag >=result) {
        result=0;
      } else {
        result -=parseFloat(mag);
      }
    }
    return result.toFixed(2);
  };

 getFileNames = async (count) => {
    const response = await GetFileName.getUploadFileName(count);
    return response;
  };

  updateReciept = (state, data) => {
    this.setState(prevState => ({ ...prevState, [state]: { ...prevState?.[state], ...data } }));
  }

  updateErrorState = (data) => {
    this.setState({ fieldErrors: data });
  }

  updateCategories = (data) => {
    this.setState({ allCategories: data });
  }

  handleAnswerChanged = (section, answer, fieldId, index, contract_id) => {
    const { allCategories } = this.state;
    const filterCategories = contract_id && allCategories.filter(obj => obj?.contract?.id?.toString() === contract_id?.toString());
    if (section === 'categories') {
      let filterData = filterCategories.find((e, i) => i === index);
      if (filterData) {
        filterData[fieldId] = answer;
        filterData.percentage_rent = (answer * filterData?.rate)/100;
      }
      filterCategories.splice(index, 1, filterData);
      this.setState({
        [section]: filterCategories
      });
    } else if (section === 'info') {
      if (fieldId === 'month') {
        let quarter = getQuarter(answer);
        this.setState(prevState => ({
          info: { ...prevState.info,
            [fieldId]: answer,
            quarter
          }
        }));
      }
      this.setState(prevState => ({
        info: { ...prevState.info, [fieldId]: answer }
      }));
    } else {
      this.setState(prevState => ({
        [section]: {
          ...prevState[section],
          [fieldId]: answer
        }
      }));
    }
  }

  handleFieldErrorChanged = (id, value) => {
    this.setState(prevState => ({
      fieldErrors: {
        ...prevState.fieldErrors,
        [id]: value
      }
    }));
  }


  handleSearchForUser = (value) => {
    const { actionSearchUser } = this.props;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      actionSearchUser(value);
    }, 300);
  }


 doS3Upload = async (files, fileIds, entity) => {
    const response = await S3Uploads.uploadFiles(files, fileIds.filename, entity);
    return response;
  };

  handleUploadAttachment = async (attachments, entity) => {
    const attachmentIds = [];
    const newAttachments = [];
    if (attachments && attachments.length > 0) {
      attachments.forEach((e) => {
        if (!e.id) {
          newAttachments.push(e);
        }
      });
    }
    let fileIds = '';
    if (newAttachments.length > 0) {
      fileIds = await this.getFileNames(newAttachments.length);
    }
    if (fileIds) {
      await this.doS3Upload(newAttachments, fileIds, entity)
        .then(() => {
          fileIds.filename.forEach((id) => {
            attachmentIds.push(id.toString());
          });
        });
    }
    return attachmentIds;
  };

  create = async (isDraft) => {
    const {
      actionCreate,
      user,
      gross_contracts,
      actionEdit
    } = this.props;

    const {
      info,
      fieldErrors, categories, allCategories
    } = this.state;
    const id = this.props.match.params.id;
    const matchingContract = gross_contracts?.find(contract => contract?.id?.toString() === info?.contract.toString());
    const min_val = matchingContract ? parseFloat(matchingContract.min_annual_gurantee).toFixed(2) : '0.00';
    const categoriesToFilter = categories?.length > 0 ? categories : allCategories;
    const filterCategories = info?.contract && categoriesToFilter.filter(obj => info?.contract.toString() === obj?.contract?.id?.toString()) || [];
    const isGrossSale = filterCategories?.some(item => !item.gross_sales);
    let attachmentFields = info?.attachments;
    const noErrors = Object.keys(fieldErrors).every(k => (fieldErrors[k] === false));
    if (!isDraft && (!noErrors || isGrossSale)) {
      this.setState({ showFormErrors: true });
      return;
    }

    this.setState({ loadingStatus: true });
    const data = {
      ...info,
      logged_by: info.logged_by.id,
      tenant: user.current_tenant?.id || user.tenant[0].id
    };
    data.status = !isDraft ? 1 : 0;
    if (!data.contract) delete data.contract;
    const formData = new FormData();
    Object.keys(data).forEach((k) => {
      if (k !== 'attachments') {
        formData.append(k, data[k]);
      }
    });

    const totalRentDue = this.getTotalRent(filterCategories, 'total');
    const rentBalance = this.getTotalRent(filterCategories, 'rent', min_val);
    const totalGrossSales = this.getTotalRent(filterCategories, 'gross_sales');

    formData.append('email_date', moment().format());
    formData.append('source', 'Tenant Portal');
    formData.append('category_items', JSON.stringify(filterCategories));
    formData.append('total_rent_due', isNaN(totalRentDue) ? 0.00 : totalRentDue);
    formData.append('rent_balance', isNaN(rentBalance) ? 0.00 : rentBalance);
    formData.append('total_gross_sales', isNaN(totalGrossSales) ? 0.00 : totalGrossSales);
    formData.append('min_annual_guarantee', min_val);
    if (attachmentFields) {
      attachmentFields = await this.handleUploadAttachment(attachmentFields, 'gross_reciept');
      info.attachments = attachmentFields;
      attachmentFields.forEach((attachment) => {
        formData.append('attachments', attachment);
      });
    }
    if (!id) {
      actionCreate(formData);
    } else {
      actionEdit(id, formData);
    }
  }

  handleCancel = () => {
    const { history }= this.props;
    history.push('/gross_receipts/list');
  }

  render() {
    const { userlist, translations, user, gross_contracts, match, gross_receipts } = this.props;
    const { info, showFormErrors, loadingStatus, allCategories } = this.state;
    const translationMap = translations ? translations[user.language] : {};

    return (
    <>
      <SectionHeader icon={icon} translationID="shortcuts.gross" defaultTitle="Gross Receipts" />
      <HeaderBack
        translationID="inspections.new.prev"
        translationDefault="Back"
        backRoute={'/gross_receipts/list'}
      />
      {loadingStatus && (<Loading loadingStatus={loadingStatus} />)}
      <div className={`container ${WorkorderStyles.form}`}>
        <Panel title="workorders.start.sss" defaultTitle={`${match?.params?.id ? 'Edit' : 'Create'} Gross Receipt`}>
          <div className={`${WorkorderStyles.content} ${WorkorderStyles.embedded}`}>
            {allCategories?.length > 0 && (
            <FixedFeilds
              info={info}
              translation={translationMap}
              userlist={userlist}
              user={user}
              allCategories={allCategories}
              searchForUser={this.handleSearchForUser}
              handleAnswerChanged={this.handleAnswerChanged}
              handleFieldErrorChanged={this.handleFieldErrorChanged}
              showFormErrors={showFormErrors}
              prefix={user.urls.currency || '$'}
              getTotalRent={this.getTotalRent}
              gross_contracts={gross_contracts}
            />
            )}
          </div>
          <div className={`${WorkorderStyles.footer} ${WorkorderStyles.embedded}`}>
            <Button onClick={this.handleCancel} translationID="maintenance.new.cancel"
              defaultText="Cancel" action="secondary"
            />
          {(!match?.params?.id || (match?.params?.id && gross_receipts?.status === 0)) && (
            <Button
              action="tertiary"
              onClick={() => this.create(true)}
              translationID="inspections.complete_inspections.save_as_draft"
              defaultText="Save as Draft"
            />
            )}
            <Button onClick={() => this.create(false)} translationID="wildlife.form.submit"
              defaultText="Submit"
            />
          </div>
        </Panel>
      </div>
    </>
    );
  }
}

GrossRecieptsSubmission.propTypes = {
  history: PropTypes.shape({}).isRequired,
  actionCreate: PropTypes.func.isRequired,
  userlist: PropTypes.arrayOf(PropTypes.shape({}))
};

GrossRecieptsSubmission.defaultProps = {
  userlist: []
};
const mapStateToProps = state => ({
  user: state.auth.profile,
  userlist: state.inspection.userlist,
  translations: state.auth.translations,
  createRecieptAction: state.grossReciepts.createRecieptAction,
  gross_contracts: state.grossReciepts.gross_contracts,
  gross_receipts: state.grossReciepts.gross_receipts_detail,
  contractsAction: state.grossReciepts.contractsAction,
  fetchRecieptsAction: state.grossReciepts.fetchRecieptsAction
});

const mapDispatchToProps = dispatch => ({
  actionCreate: (data) => {
    dispatch(creatGrossReciepts(data));
  },
  actionEdit: (id, data) => {
    dispatch(editGrossReciepts(id, data));
  },
  getContractList: () => {
    dispatch(getContracts());
  },
  actiondetails: (id) => {
    dispatch(getGrossRecieptDetail(id));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(GrossRecieptsSubmission);
